<template>
	<div :class="['application-career-characteristic-edit', { 'has-items': hasItems }]">
		<div class="left">
			<div class="left1">
				<span class="icon-container">
					<Icon :icon="hasItems ? 'checkmark' : 'question-mark'"/>
				</span>
			</div>
			<div class="left2">
				<template v-if="hasItems">
					<SelectedItems
						:characteristic-items="editConfig.characteristicItems"
						:characteristic-type="editConfig.characteristicType"
						:selected="items"
						class="no-left-padding"
					/>
				</template>
				<template v-else>
					<a href="#" @click.prevent="openFan">{{ openFanLabel }}</a>
				</template>
			</div>
		</div>
		<div v-if="hasItems" class="actions">
			<a href="#" @click.prevent="openFan">
				<Icon icon="pencil"/>
			</a>
		</div>
	</div>
</template>

<script>
import {arrayIsNotEmpty} from "@/helper/Array";
import Icon from "@/vue/icon/Icon.vue";
import {mapActions} from "vuex";
import {APPLICATION} from "@/helper/characteristic/Label";
import SelectedItems from "@/vue/characteristic/SelectedItems.vue";

export default {
	components: {SelectedItems, Icon},

	props: {
		value: {
			type: Array,
			required: false,
		},
		editConfig: {
			type: Object,
			required: true
		},
		openFanLabel: {
			type: String,
			required: true,
		}
	},

	data ()
	{
		return {
			items: this.value,
		};
	},

	computed: {
		hasItems ()
		{
			return this.items && arrayIsNotEmpty(this.items);
		}
	},

	methods: {
		...mapActions('characteristic/fan', {
			'showFan': 'show'
		}),
		openFan ()
		{
			this.showFan({
				selected: this.items,
				characteristicType: this.editConfig.characteristicType,
				characteristicItems: this.editConfig.characteristicItems,
				title: this.editConfig.title,
				withKeyword: this.editConfig.withKeyword,
				supplementsConfig: this.editConfig.supplementsConfig,
				singleChoice: this.editConfig.singleChoice,
				labelType: APPLICATION,
				searchConfig: this.editConfig.searchConfig,
				onChange: ({selected}) =>
				{
					this.items = selected;

					this.emitChangeEvent();
				}
			});
		},
		emitChangeEvent ()
		{
			this.$emit('input', this.items);
		},
	},

	watch: {
		value (v)
		{
			this.items = v;
		}
	}
}
</script>
